import { MaterialIconName } from '@gorila-shared-ui/components';
import { CustomTheme } from '../theme/customTheme';
import { getNoCommunicationTimeIntervals } from '../utils/journeys';

export const JOURNEY_STATUS_SCHEDULED = 1;
export const JOURNEY_STATUS_ACTIVE = 2;
export const JOURNEY_STATUS_FINISHED = 3;
export const JOURNEY_STATUSES: {
  type: number;
  name: string;
  icon: MaterialIconName;
  color: string;
}[] = [
  {
    type: JOURNEY_STATUS_SCHEDULED,
    name: 'Programado',
    icon: 'event_available',
    color: CustomTheme.colors.warning,
  },
  {
    type: JOURNEY_STATUS_ACTIVE,
    name: 'Activo',
    icon: 'beenhere',
    color: CustomTheme.colors.positive,
  },
  {
    type: JOURNEY_STATUS_FINISHED,
    name: 'Terminado',
    icon: 'verified',
    color: CustomTheme.colors.negative,
  },
];

export const JOURNEY_SORT_START_DATE = 'startDate';
export const JOURNEY_SORT_END_DATE = 'endDate';
export const JORNEY_SORT_OPTIONS = [
  {
    id: JOURNEY_SORT_START_DATE,
    label: 'Fecha inicio',
  },
  {
    id: JOURNEY_SORT_END_DATE,
    label: 'Fecha fin',
  },
];

export const NO_COMMUNICATION_TIME_OPTIONS = getNoCommunicationTimeIntervals().map((time) => ({
  id: time,
  label: time,
}));
export const NO_COMMUNICATION_TIME_DEFAULT = 60;

export const JOURNEY_START_POINT = 'start';
export const JOURNEY_END_POINT = 'end';
